import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconSwapHoriz = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 10,
	viewBox: "0 0 12 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.66 4.33301L0 6.99967L2.66 9.66634V7.66634H7.33333V6.33301H2.66V4.33301ZM12 2.99967L9.34 0.333008V2.33301H4.66667V3.66634H9.34V5.66634L12 2.99967Z",
		fill: "#959595"
	})
});
export default SvgIconSwapHoriz;
